import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import map from "lodash/map";

import Modal from "../../Common/ModalGeneric";
import Table from "../../Common/Tables/BaseTable";
import { getBetjentTeamHistorikk } from "../../../actions/bybetjenterActions";
import {
  toNorwegianDatetime,
  toNorwegianDateFormat,
} from "../../../utils/date";

function BypatruljeTeamHistorikk({ bybetjentId, tjenestenummer }) {
  const dispatch = useDispatch();
  const teamHistorikk = useSelector((state) => state.betjentTeamHistorikk);
  const [open, setOpen] = useState(false);

  const openModal = () => {
    if (bybetjentId) {
      dispatch(getBetjentTeamHistorikk(bybetjentId));
    }
    setOpen(true);
  };

  const closeModal = () => setOpen(false);

  const headerRow = ["Dato fra", "Dato til", "Team"];
  return (
    <Modal
      modalTitle={`Teamhistorikk for tjenestenummer ${tjenestenummer}`}
      open={open}
      closeModal={closeModal}
      openModal={openModal}
      isButtonLink
      popUpButtonText={tjenestenummer}
      hasSubmitButton={false}
      closeButtonText="Lukk"
    >
      <Table headerRow={headerRow} striped>
        <tbody>
          {map(teamHistorikk, (i, index) => (
            <tr key={index}>
              <td>{toNorwegianDateFormat(toNorwegianDatetime(i.datoFra))}</td>
              <td>{toNorwegianDateFormat(toNorwegianDatetime(i.datoTil))}</td>
              <td>{i.team}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Modal>
  );
}

export default BypatruljeTeamHistorikk;
